import { useCallback, useEffect, useRef } from 'react'
import { AsyncSelect } from './async-select'
import { EndlessAsyncSelectProps } from './endless-async-select.types'

const SCROLL_THRESHOLD = 50

export const EndlessAsyncSelect: React.FC<EndlessAsyncSelectProps> = ({
  onScrollEnd,
  hasMore,
  ...asyncSelectProps
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const onScrollEndRef = useRef(onScrollEnd)
  const hasMoreRef = useRef(hasMore)

  onScrollEndRef.current = onScrollEnd
  hasMoreRef.current = hasMore

  const handleScroll = useCallback((e: Event) => {
    if (!onScrollEndRef.current || !hasMoreRef.current) return

    const target = e.target as HTMLElement
    const { scrollTop, scrollHeight, clientHeight } = target

    if (scrollHeight - scrollTop - clientHeight <= SCROLL_THRESHOLD) {
      onScrollEndRef.current()
    }
  }, [])

  useEffect(() => {
    const container = containerRef.current
    if (!container) return

    container.addEventListener('scroll', handleScroll, true)

    return () => {
      container.removeEventListener('scroll', handleScroll, true)
    }
  }, [handleScroll])

  return (
    <div ref={containerRef} style={{ display: 'contents' }}>
      <AsyncSelect {...asyncSelectProps} />
    </div>
  )
}
